import { createAction, createSlice } from '@reduxjs/toolkit';


export type impLink = {
    links: string | string[],
    text: string,
}


const initialState: impLink = {
    links: '',
    text: '',
};

export const revertAll = createAction('REVERT_ALL');

// Redux Toolkit slice
export const impLinkReducer: any = createSlice({
    name: 'impLink',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setImpLink: (state, action) => {
            return {
                ...action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(revertAll, () => initialState);
    },
});
export const { setImpLink } = impLinkReducer.actions;
export default impLinkReducer;